import L from 'leaflet';

// ─── Helper: wrap SVG content into a Leaflet divIcon ─────────────────────────
const makeIcon = (svgContent, size = 44) => {
  return L.divIcon({
    html: svgContent,
    className: 'annotation-marker-icon',
    iconSize: [size, size],
    iconAnchor: [size / 2, size / 2],
    popupAnchor: [0, -(size / 2)],
  });
};

// ─── Traffic & Routing ────────────────────────────────────────────────────────

const speedSign = (num) => `
  <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44">
    <circle cx="22" cy="22" r="20" fill="white" stroke="#CC0000" stroke-width="4"/>
    <text x="22" y="27" text-anchor="middle" font-family="Arial,sans-serif" font-size="${num >= 100 ? 13 : 16}" font-weight="bold" fill="#111">${num}</text>
  </svg>`;

const stopSign = () => `
  <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44">
    <polygon points="14,4 30,4 40,14 40,30 30,40 14,40 4,30 4,14" fill="#CC0000" stroke="#8B0000" stroke-width="1.5"/>
    <text x="22" y="26" text-anchor="middle" font-family="Arial,sans-serif" font-size="10" font-weight="bold" fill="white">STOP</text>
  </svg>`;

const giveWaySign = () => `
  <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44">
    <polygon points="22,4 42,40 2,40" fill="white" stroke="#CC0000" stroke-width="3.5"/>
    <polygon points="22,12 36,38 8,38" fill="none" stroke="#CC0000" stroke-width="2"/>
  </svg>`;

const arrowSign = (arrowPath, color = '#2563EB') => `
  <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44">
    <rect x="2" y="2" width="40" height="40" rx="6" fill="${color}"/>
    ${arrowPath}
  </svg>`;

const noEntrySign = () => `
  <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44">
    <circle cx="22" cy="22" r="20" fill="#CC0000" stroke="#8B0000" stroke-width="1.5"/>
    <rect x="10" y="18" width="24" height="8" rx="2" fill="white"/>
  </svg>`;

const roundaboutSign = () => `
  <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44">
    <rect x="2" y="2" width="40" height="40" rx="6" fill="#2563EB"/>
    <circle cx="22" cy="22" r="10" fill="none" stroke="white" stroke-width="3"/>
    <polygon points="22,10 26,16 22,14 18,16" fill="white"/>
  </svg>`;

// ─── Safety & Hazards ─────────────────────────────────────────────────────────

const warningSign = (iconPath) => `
  <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44">
    <polygon points="22,3 41,39 3,39" fill="#FBBF24" stroke="#D97706" stroke-width="2"/>
    ${iconPath}
  </svg>`;

const safetyCircle = (color, iconPath) => `
  <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44">
    <circle cx="22" cy="22" r="20" fill="${color}"/>
    ${iconPath}
  </svg>`;

const restrictedZone = () => `
  <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44">
    <circle cx="22" cy="22" r="20" fill="#CC0000" stroke="#8B0000" stroke-width="1.5"/>
    <text x="22" y="28" text-anchor="middle" font-family="Arial,sans-serif" font-size="18" font-weight="bold" fill="white">R</text>
  </svg>`;

// ─── Facilities & Wayfinding ──────────────────────────────────────────────────

const facilitySign = (bg, content) => `
  <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44">
    <rect x="2" y="2" width="40" height="40" rx="6" fill="${bg}"/>
    ${content}
  </svg>`;

const firstAid = () => `
  <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44">
    <rect x="2" y="2" width="40" height="40" rx="6" fill="#16A34A"/>
    <rect x="18" y="10" width="8" height="24" rx="2" fill="white"/>
    <rect x="10" y="18" width="24" height="8" rx="2" fill="white"/>
  </svg>`;

const fireExtinguisher = () => `
  <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44">
    <circle cx="22" cy="22" r="20" fill="#CC0000"/>
    <rect x="18" y="14" width="8" height="16" rx="3" fill="white"/>
    <ellipse cx="22" cy="13" rx="5" ry="3" fill="white"/>
    <path d="M22 10 L28 8" stroke="white" stroke-width="2"/>
  </svg>`;

const emergencyAssembly = () => `
  <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44">
    <rect x="2" y="2" width="40" height="40" rx="6" fill="#16A34A"/>
    <circle cx="22" cy="14" r="4" fill="white"/>
    <path d="M16 34 L22 22 L28 34" stroke="white" stroke-width="2.5" fill="none" stroke-linecap="round"/>
    <path d="M15 26 L29 26" stroke="white" stroke-width="2.5" stroke-linecap="round"/>
    <path d="M30 20 L35 18 L36 23" stroke="white" stroke-width="2" fill="none"/>
  </svg>`;

const gateEntry = () => `
  <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44">
    <rect x="2" y="2" width="40" height="40" rx="6" fill="#2563EB"/>
    <rect x="8" y="16" width="12" height="18" rx="1" fill="none" stroke="white" stroke-width="2"/>
    <rect x="24" y="16" width="12" height="18" rx="1" fill="none" stroke="white" stroke-width="2"/>
    <line x1="8" y1="10" x2="8" y2="16" stroke="white" stroke-width="2.5"/>
    <line x1="36" y1="10" x2="36" y2="16" stroke="white" stroke-width="2.5"/>
    <line x1="6" y1="10" x2="38" y2="10" stroke="white" stroke-width="2"/>
  </svg>`;

// ─── Pedestrian ───────────────────────────────────────────────────────────────

const pedestrianIcon = () => `
  <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44">
    <circle cx="22" cy="22" r="20" fill="#2563EB"/>
    <circle cx="22" cy="13" r="3.5" fill="white"/>
    <path d="M22 17 L22 29 M17 21 L27 21 M19 29 L22 37 M25 29 L22 37" stroke="white" stroke-width="2.2" fill="none" stroke-linecap="round"/>
  </svg>`;

const pedestrianCrossing = () => `
  <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44">
    <rect x="2" y="2" width="40" height="40" rx="6" fill="#2563EB"/>
    <rect x="10" y="26" width="24" height="4" fill="white"/>
    <rect x="10" y="32" width="24" height="4" fill="white"/>
    <circle cx="22" cy="13" r="3" fill="white"/>
    <path d="M22 16 L22 25 M18 19 L26 19" stroke="white" stroke-width="2" fill="none" stroke-linecap="round"/>
  </svg>`;

const footpath = () => `
  <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44">
    <rect x="2" y="2" width="40" height="40" rx="6" fill="#2563EB"/>
    <line x1="22" y1="8" x2="22" y2="14" stroke="white" stroke-width="3" stroke-linecap="round"/>
    <line x1="22" y1="19" x2="22" y2="25" stroke="white" stroke-width="3" stroke-linecap="round"/>
    <line x1="22" y1="30" x2="22" y2="36" stroke="white" stroke-width="3" stroke-linecap="round"/>
  </svg>`;

const noPedestrian = () => `
  <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44">
    <circle cx="22" cy="22" r="20" fill="white" stroke="#CC0000" stroke-width="3.5"/>
    <circle cx="22" cy="14" r="3" fill="#333"/>
    <path d="M22 17 L22 27 M18 20 L26 20" stroke="#333" stroke-width="2" fill="none" stroke-linecap="round"/>
    <line x1="6" y1="6" x2="38" y2="38" stroke="#CC0000" stroke-width="4" stroke-linecap="round"/>
  </svg>`;

// ─── Biosecurity ──────────────────────────────────────────────────────────────

const washdown = () => `
  <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44">
    <circle cx="22" cy="22" r="20" fill="#2563EB"/>
    <path d="M16 14 L28 14 L28 22 Q22 26 16 22 Z" fill="white"/>
    <line x1="14" y1="28" x2="14" y2="34" stroke="white" stroke-width="2" stroke-linecap="round"/>
    <line x1="19" y1="28" x2="18" y2="34" stroke="white" stroke-width="2" stroke-linecap="round"/>
    <line x1="24" y1="28" x2="24" y2="34" stroke="white" stroke-width="2" stroke-linecap="round"/>
    <line x1="29" y1="28" x2="30" y2="34" stroke="white" stroke-width="2" stroke-linecap="round"/>
  </svg>`;

const checkpoint = () => `
  <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44">
    <circle cx="22" cy="22" r="20" fill="#CC0000"/>
    <line x1="8" y1="22" x2="36" y2="22" stroke="white" stroke-width="4" stroke-linecap="round"/>
    <line x1="8" y1="14" x2="8" y2="30" stroke="white" stroke-width="2.5"/>
    <line x1="36" y1="14" x2="36" y2="30" stroke="white" stroke-width="2.5"/>
  </svg>`;

const biosecurityZone = () => `
  <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44">
    <path d="M22 4 L38 12 L38 26 Q38 36 22 42 Q6 36 6 26 L6 12 Z" fill="#7C3AED" stroke="#5B21B6" stroke-width="1.5"/>
    <text x="22" y="28" text-anchor="middle" font-family="Arial,sans-serif" font-size="16" font-weight="bold" fill="white">B</text>
  </svg>`;

// ─── Icon definitions map ─────────────────────────────────────────────────────

const ICON_DEFS = {
  // Traffic & Routing
  speed_10:   { svg: speedSign(10),   label: 'Speed 10 km/h',  category: 'traffic' },
  speed_15:   { svg: speedSign(15),   label: 'Speed 15 km/h',  category: 'traffic' },
  speed_20:   { svg: speedSign(20),   label: 'Speed 20 km/h',  category: 'traffic' },
  speed_30:   { svg: speedSign(30),   label: 'Speed 30 km/h',  category: 'traffic' },
  speed_40:   { svg: speedSign(40),   label: 'Speed 40 km/h',  category: 'traffic' },
  speed_50:   { svg: speedSign(50),   label: 'Speed 50 km/h',  category: 'traffic' },
  stop_sign:  { svg: stopSign(),      label: 'Stop Sign',       category: 'traffic' },
  give_way:   { svg: giveWaySign(),   label: 'Give Way',        category: 'traffic' },
  one_way:    {
    svg: arrowSign('<polygon points="22,10 32,22 26,22 26,34 18,34 18,22 12,22" fill="white"/>'),
    label: 'One Way', category: 'traffic'
  },
  turn_left:  {
    svg: arrowSign('<path d="M28 32 L28 20 Q28 14 22 14 L16 14 L20 10 M16 14 L20 18" stroke="white" stroke-width="3" fill="none" stroke-linecap="round" stroke-linejoin="round"/>'),
    label: 'Turn Left', category: 'traffic'
  },
  turn_right: {
    svg: arrowSign('<path d="M16 32 L16 20 Q16 14 22 14 L28 14 L24 10 M28 14 L24 18" stroke="white" stroke-width="3" fill="none" stroke-linecap="round" stroke-linejoin="round"/>'),
    label: 'Turn Right', category: 'traffic'
  },
  straight:   {
    svg: arrowSign('<polygon points="22,10 28,20 24,20 24,34 20,34 20,20 16,20" fill="white"/>'),
    label: 'Straight', category: 'traffic'
  },
  u_turn:     {
    svg: arrowSign('<path d="M16 32 L16 18 Q16 12 22 12 Q28 12 28 18 L28 24 L32 20 M28 24 L24 20" stroke="white" stroke-width="3" fill="none" stroke-linecap="round" stroke-linejoin="round"/>'),
    label: 'U-Turn', category: 'traffic'
  },
  no_entry:   { svg: noEntrySign(),   label: 'No Entry',        category: 'traffic' },
  keep_left:  {
    svg: arrowSign('<text x="22" y="28" text-anchor="middle" font-family="Arial,sans-serif" font-size="11" font-weight="bold" fill="white">KL</text>'),
    label: 'Keep Left', category: 'traffic'
  },
  keep_right: {
    svg: arrowSign('<text x="22" y="28" text-anchor="middle" font-family="Arial,sans-serif" font-size="11" font-weight="bold" fill="white">KR</text>'),
    label: 'Keep Right', category: 'traffic'
  },
  roundabout: { svg: roundaboutSign(), label: 'Roundabout',     category: 'traffic' },

  // Safety & Hazards
  warning: {
    svg: warningSign('<text x="22" y="35" text-anchor="middle" font-family="Arial,sans-serif" font-size="18" font-weight="bold" fill="#111">!</text>'),
    label: 'Warning', category: 'safety'
  },
  hard_hat: {
    svg: safetyCircle('#2563EB', '<path d="M12 26 Q12 16 22 16 Q32 16 32 26 Z" fill="white"/><rect x="10" y="26" width="24" height="4" rx="1" fill="white"/>'),
    label: 'Hard Hat Required', category: 'safety'
  },
  hi_vis: {
    svg: safetyCircle('#EA580C', '<path d="M16 14 L28 14 L30 30 L22 28 L14 30 Z" fill="white" opacity="0.9"/><line x1="14" y1="20" x2="30" y2="20" stroke="#EA580C" stroke-width="2"/>'),
    label: 'Hi-Vis Required', category: 'safety'
  },
  ear_protection: {
    svg: safetyCircle('#2563EB', '<circle cx="14" cy="22" r="5" fill="white"/><circle cx="30" cy="22" r="5" fill="white"/><path d="M14 17 Q22 12 30 17" stroke="white" stroke-width="2.5" fill="none"/>'),
    label: 'Ear Protection', category: 'safety'
  },
  eye_protection: {
    svg: safetyCircle('#2563EB', '<path d="M8 22 Q22 14 36 22 Q22 30 8 22 Z" fill="white"/><circle cx="22" cy="22" r="4" fill="#2563EB"/><circle cx="22" cy="22" r="2" fill="white"/>'),
    label: 'Eye Protection', category: 'safety'
  },
  restricted_zone: { svg: restrictedZone(), label: 'Restricted Zone', category: 'safety' },
  chemical_hazard: {
    svg: warningSign('<path d="M19 26 Q22 20 25 26 L28 32 L16 32 Z" fill="#333"/><line x1="22" y1="18" x2="22" y2="23" stroke="#333" stroke-width="2"/>'),
    label: 'Chemical Hazard', category: 'safety'
  },
  electrical_hazard: {
    svg: warningSign('<polygon points="25,18 18,27 22,27 19,36 26,25 22,25" fill="#333"/>'),
    label: 'Electrical Hazard', category: 'safety'
  },

  // Facilities & Wayfinding
  parking: {
    svg: facilitySign('#2563EB', '<text x="22" y="30" text-anchor="middle" font-family="Arial,sans-serif" font-size="24" font-weight="bold" fill="white">P</text>'),
    label: 'Parking', category: 'facility'
  },
  loading_dock: {
    svg: facilitySign('#2563EB', '<rect x="10" y="22" width="24" height="14" rx="1" fill="white"/><path d="M10 22 L22 14 L34 22" fill="white"/><rect x="18" y="28" width="8" height="8" fill="#2563EB"/>'),
    label: 'Loading Dock', category: 'facility'
  },
  weighbridge: {
    svg: facilitySign('#2563EB', '<rect x="10" y="24" width="24" height="8" rx="2" fill="white"/><line x1="22" y1="14" x2="22" y2="24" stroke="white" stroke-width="2"/><circle cx="22" cy="13" r="3" fill="none" stroke="white" stroke-width="2"/><line x1="14" y1="13" x2="30" y2="13" stroke="white" stroke-width="1.5"/>'),
    label: 'Weighbridge', category: 'facility'
  },
  office: {
    svg: facilitySign('#2563EB', '<rect x="10" y="14" width="24" height="20" rx="1" fill="white"/><rect x="14" y="28" width="16" height="6" fill="#2563EB"/><rect x="13" y="18" width="7" height="5" fill="#2563EB" rx="1"/><rect x="24" y="18" width="7" height="5" fill="#2563EB" rx="1"/>'),
    label: 'Office/Reception', category: 'facility'
  },
  first_aid:           { svg: firstAid(),         label: 'First Aid',           category: 'facility' },
  fire_extinguisher:   { svg: fireExtinguisher(),  label: 'Fire Extinguisher',   category: 'facility' },
  emergency_assembly:  { svg: emergencyAssembly(), label: 'Emergency Assembly',  category: 'facility' },
  gate_entry:          { svg: gateEntry(),         label: 'Gate/Entry',          category: 'facility' },

  // Pedestrian
  pedestrian:          { svg: pedestrianIcon(),    label: 'Pedestrian',          category: 'pedestrian' },
  pedestrian_crossing: { svg: pedestrianCrossing(),label: 'Pedestrian Crossing', category: 'pedestrian' },
  footpath:            { svg: footpath(),           label: 'Footpath',            category: 'pedestrian' },
  no_pedestrian:       { svg: noPedestrian(),       label: 'No Pedestrian',       category: 'pedestrian' },

  // Text Label
  text_label: {
    svg: `<svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44">
      <rect x="2" y="12" width="40" height="20" rx="4" fill="white" stroke="#374151" stroke-width="2"/>
      <text x="22" y="26" text-anchor="middle" font-family="Arial,sans-serif" font-size="12" font-weight="bold" fill="#111">Aa</text>
    </svg>`,
    label: 'Text Label',
    category: 'drawing',
  },

  // Biosecurity
  washdown:            { svg: washdown(),          label: 'Wash-down',           category: 'biosecurity' },
  checkpoint:          { svg: checkpoint(),        label: 'Checkpoint',          category: 'biosecurity' },
  biosecurity_zone:    { svg: biosecurityZone(),   label: 'Biosecurity Zone',    category: 'biosecurity' },
};

// ─── Category metadata ────────────────────────────────────────────────────────

export const ANNOTATION_CATEGORIES = [
  {
    key: 'traffic',
    label: 'Traffic & Routing',
    color: '#2563EB',
    toolbarSvg: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="9"/><text x="12" y="16" text-anchor="middle" font-size="9" font-weight="bold" fill="currentColor" stroke="none">10</text></svg>`,
  },
  {
    key: 'safety',
    label: 'Safety & Hazards',
    color: '#D97706',
    toolbarSvg: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polygon points="12,3 22,21 2,21"/><line x1="12" y1="9" x2="12" y2="14"/><circle cx="12" cy="17" r="1" fill="currentColor" stroke="none"/></svg>`,
  },
  {
    key: 'facility',
    label: 'Facilities & Wayfinding',
    color: '#059669',
    toolbarSvg: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="18" height="18" rx="2"/><text x="12" y="17" text-anchor="middle" font-size="12" font-weight="bold" fill="currentColor" stroke="none">P</text></svg>`,
  },
  {
    key: 'pedestrian',
    label: 'Pedestrian',
    color: '#2563EB',
    toolbarSvg: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="5" r="2"/><path d="M12 7 L12 15 M9 10 L15 10 M10 15 L12 20 M14 15 L12 20"/></svg>`,
  },
  {
    key: 'biosecurity',
    label: 'Biosecurity',
    color: '#7C3AED',
    toolbarSvg: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 2 L20 7 L20 14 Q20 20 12 23 Q4 20 4 14 L4 7 Z"/></svg>`,
  },
];

// ─── Public API ───────────────────────────────────────────────────────────────

export const getIconDef = (type) => ICON_DEFS[type] || null;

export const getLeafletIcon = (type) => {
  const def = ICON_DEFS[type];
  if (!def) return L.divIcon({ html: '<div style="width:20px;height:20px;background:#666;border-radius:50%"/>', iconSize: [20, 20], iconAnchor: [10, 10] });
  return makeIcon(def.svg);
};

export const getIconsByCategory = (category) =>
  Object.entries(ICON_DEFS)
    .filter(([, def]) => def.category === category)
    .map(([key, def]) => ({ key, label: def.label, svg: def.svg, category: def.category }));

export const getAllIconDefs = () => ICON_DEFS;
